import React from 'react';
import { IndigoAppContextType } from 'app/AppContext';
import { currencyFormatUtils } from '@instinet-analytics/core-lib';

const { c2FmtFx } = currencyFormatUtils;

export const currencyCellRenderer =
    (
        context: IndigoAppContextType,
        colFmt?: (context: IndigoAppContextType, value: unknown) => string
    ) =>
    // eslint-disable-next-line react/display-name
    (props: { value: number }) => {
        const exchangeRate = context.currencyFormat
            ? context.currencyFormat.exchangeRate!
            : 1;
        if (props.value !== undefined) {
            const formatter = colFmt ? colFmt : c2FmtFx;
            const value = props.value * exchangeRate;
            return <span>{formatter(context, value)}</span>;
        } else {
            return <span />;
        }
    };
